import axios from "axios";
import { setAlert } from "./alert";
import {
    SEND_NOTIFICATION,
    SEND_NOTIFICATION_SUCCESS,
    SEND_NOTIFICATION_ERROR,
    GET_NOTIFICATION_TASK_REQUEST,
    GET_NOTIFICATION_TASK_SUCCESS,
    GET_NOTIFICATION_TASK_FAILURE,
    CANCEL_NOTIFICATION_TASK_SUCCESS,
    CANCEL_NOTIFICATION_TASK_REQUEST,
    CANCEL_NOTIFICATION_TASK_FAILURE,
    SEARCH_NOTIFICATION_REQUEST,
    SEARCH_NOTIFICATION_SUCCESS,
    SEARCH_NOTIFICATION_FAILURE,
    GET_USER,
    USER_ERROR
} from "./types";
import env from "../env";
import { notificationService } from "../services";
import { notificationListPageSize } from "../components/notificationManagement/notificationConstant";
import customConfig from "../config";

const config = {
    headers: {
        "Content-Type": "application/json",
    }
};

const getConfig = ( tenantId) => {
    return {
        userConfig: {
            headers: {
                "Content-Type": "application/json",
                "X-Tenant-ID": tenantId,
            }
        },
        url: env.GET_USERMANAGEMENT_API_URL()
    };
}

const getApiResponseMessage = (data) => {
    const message = data?.message;
    return typeof message === "string" && message.trim() !== "" ? message.trim() : null;
};

const getCreateNotificationSuccessMessage = (requestData, responseData) => {
    const channelType = requestData?.channel?.type || responseData?.channel?.type;
    if (channelType === "email") {
        return "Email notification created successfully.";
    }
    if (channelType === "push") {
        return "Push notification created successfully.";
    }
    return "Notification created successfully.";
};

export const createNotificationTask = (requestData) => (dispatch) => {
    dispatch({
        type: SEND_NOTIFICATION,
    });
    axios.post(
        `${env.GET_DEVICEMANAGEMENT_API_URL()}/simplifi/v1/notificationmanager/send`, requestData, config).then((res) => {
            dispatch({
                type: SEND_NOTIFICATION_SUCCESS,
                payload: res.data,
            });
            dispatch(setAlert(getCreateNotificationSuccessMessage(requestData, res?.data), "success"));
        }).catch((err) => {
            dispatch(setAlert(err?.response?.data?.message ?? "Failed to Create Notification", "danger"));
            dispatch({
                type: SEND_NOTIFICATION_ERROR,
                payload: {},
            });
        });
}

/** Upload notification email image; returns CloudFront URL from backend response. */
export const uploadNotificationEmailImage = (file) => {
    const formData = new FormData();
    formData.append("image", file);

    return axios.post(
        `${env.GET_DEVICEMANAGEMENT_API_URL()}/simplifi/v1/deviceservices/notification/image`,
        formData
    ).then(({ data }) => {
        const url = data?.url;
        if (!url || typeof url !== "string") {
            throw new Error("Image upload did not return a URL");
        }
        return url.trim();
    });
};

export const createEmailNotificationTask = (requestData) => (dispatch) => {
    dispatch({
        type: SEND_NOTIFICATION,
    });
    axios.post(
        `${env.GET_DEVICEMANAGEMENT_API_URL()}/simplifi/v1/deviceservices/notification/send`, requestData, config).then((res) => {
            dispatch({
                type: SEND_NOTIFICATION_SUCCESS,
                payload: res.data,
            });
            dispatch(setAlert(getCreateNotificationSuccessMessage(requestData, res?.data), "success"));
        }).catch((err) => {
            dispatch(setAlert(err?.response?.data?.message ?? "Failed to Create Notification", "danger"));
            dispatch({
                type: SEND_NOTIFICATION_ERROR,
                payload: {},
            });
        });
}

export const getNotificationTask = (taskId, action = "updateGetNotification") => (dispatch) => {
    dispatch({
        type: GET_NOTIFICATION_TASK_REQUEST,
    });
    // notificationService?.getNotificationTask(taskId).

    axios.get(
        `${env.GET_DEVICEMANAGEMENT_API_URL()}/simplifi/v1/notificationmanager/task/${taskId}`, config).then(({ data }) => {
            // console.log("here", res)
            dispatch({
                type: GET_NOTIFICATION_TASK_SUCCESS,
                payload: { data, action, taskId },
            });
        }).catch(
            (err) => {
                console.error(err)
                dispatch(setAlert((err?.response?.data?.message ?? "Failed to fetch Notification Task details") + "- Task ID: " + taskId, "danger"));
                dispatch({
                    type: GET_NOTIFICATION_TASK_FAILURE,
                    payload: { taskId },
                });
            })
}

export const searchNotificationsByUserId = (userId, pgIndex = 1, severity = null, pgSize = notificationListPageSize) => (dispatch) => {
    dispatch({
        type: SEARCH_NOTIFICATION_REQUEST,
    });
    axios.get(
        `${env.GET_DEVICEMANAGEMENT_API_URL()}/simplifi/v1/notificationmanager/log?userId=${userId}&pgIndex=${pgIndex}&pgSize=${pgSize}${severity === null ? "" : `&severity=${severity}`}`, config).then(({ data }) => {
            // console.log("here", res)
            dispatch({
                type: SEARCH_NOTIFICATION_SUCCESS,
                payload: data,
            });
        }).catch(
            (err) => {
                console.error(err)
                dispatch(setAlert((err?.response?.data?.message ?? "Failed to fetch Notification Data") + "- User ID: " + userId, "danger"));
                dispatch({
                    type: SEARCH_NOTIFICATION_FAILURE,
                    payload: {},
                });
            })
}

export const searchNotifications = (searchBy, searchStr, pgIndex = 1, tenantId, pgSize = notificationListPageSize) => (dispatch) => {
    dispatch({
        type: SEARCH_NOTIFICATION_REQUEST,
    });
    if (!/\S+@\S+\.\S+/.test(searchStr) && searchBy === "email") {
        dispatch(setAlert(("Please enter a valid E-mail ID") + ` - User ${searchBy}: ` + searchStr, "danger"));
        dispatch({
            type: SEARCH_NOTIFICATION_FAILURE,
            payload: {},
        });
        return
    }
    else if (!/^\+[1-9]{1}[0-9]{3,14}$/.test(searchStr) && searchBy === "mobile") {
        dispatch(setAlert(("Please enter a valid mobile no") + ` - User ${searchBy}: ` + searchStr, "danger"));
        dispatch({
            type: SEARCH_NOTIFICATION_FAILURE,
            payload: {},
        });
        return
    }
    const { userConfig, url } = getConfig(tenantId)

    let body = {}
        body[searchBy] = searchStr
        axios.post(`${url}/simplifi/v1/userManagement/users/search`, body, userConfig)
            .then(({ data }) => {
                dispatch({
                    type: GET_USER,
                    payload: data ?.[0] ?? {},
                });
                axios.get(
                    `${env.GET_DEVICEMANAGEMENT_API_URL()}/simplifi/v1/notificationmanager/log?userId=${data?.[0]?.userId ?? ""}&pgIndex=${pgIndex}&pgSize=${pgSize}`, config).then(({ data }) => {
                        dispatch({
                            type: SEARCH_NOTIFICATION_SUCCESS,
                            payload: data,
                        });
                    }).catch(
                        (err) => {
                            dispatch(setAlert((err?.response?.data?.message ?? "Failed to fetch Notification Data") + `- User ${searchBy}: ` + searchStr, "danger"));
                            dispatch({
                                type: SEARCH_NOTIFICATION_FAILURE,
                                payload: {},
                            });
                        })
            }).catch(
                (err) => {
                    dispatch(setAlert((err?.response?.data?.message ?? "Unable to find user details") + `- User ${searchBy}: ` + searchStr, "danger"));
                    dispatch({
                        type: USER_ERROR,
                        payload: err,
                    });
                    dispatch({
                        type: SEARCH_NOTIFICATION_FAILURE,
                        payload: {},
                    });
                })

}


export const cancelNotificationTask = (taskId, cb = () => { }) => (dispatch) => {
    dispatch({
        type: CANCEL_NOTIFICATION_TASK_REQUEST,
    });

    axios.delete(
        `${env.GET_DEVICEMANAGEMENT_API_URL()}/simplifi/v1/notificationmanager/task/${taskId}`, config).then((res) => {
            dispatch({
                type: CANCEL_NOTIFICATION_TASK_SUCCESS,
                payload: res.data,
            });
            const msg = getApiResponseMessage(res?.data) || "Notification task cancelled successfully.";
            dispatch(setAlert(msg, "success"));
            cb();
        }).catch((err) => {
            dispatch(setAlert((err?.response?.data?.message ?? "Failed to cancel Notification Task details") + "- Task ID: " + taskId, "danger"));
            dispatch({
                type: CANCEL_NOTIFICATION_TASK_FAILURE,
                payload: {},
            });
        });
}


